import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AdminKioskVerifyLayout.styles';
// import {
//   AdminHeader,
//   AdminFooter,
//   AdminSideSlides,
//   AdminKioskVerifyMain,
//   KioskIdelScreen
// } from '..';

import AdminHeader from './../AdminLayout/AdminHeader';
import AdminFooter from './../AdminLayout/AdminFooter';
import AdminSideSlides from './../AdminLayout/AdminSideSlides';
import AdminKioskVerifyMain from './AdminKioskVerifyMain';
import KioskIdelScreen from './../../KioskLayout/KioskIdelScreen';

export class AdminKioskVerifyLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle: 'Scan the stock code to verify.',
    height: 300
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classNames(classes.container)}>
        <AdminHeader myLogoheight={this.state.height} />
        <AdminSideSlides
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminKioskVerifyMain />
        <AdminFooter customFooterBottom="0%" />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AdminKioskVerifyLayout);
